import { IFlyerRuntimePage } from "../../../../dtos/flyer";

export const getHeightandWidthOfFlyerPage = (
	page: IFlyerRuntimePage,
	windowHeight: number,
	windowWidth: number,
	isMobile: boolean,
	isFullScreen: boolean,
) => {
	let constant;
	let height;
	let width;
	let padding = isFullScreen ? 106 : 200;

	if(!page){
		return { height: 0, width: 0 }
	}

	if (isMobile) {
		constant = page.widthPx / (windowWidth - 20);
		width = windowWidth;
		height = page.heightPx / constant;
	} else {
		height = windowHeight - padding;
		constant = page.widthPx > page.heightPx ? page.widthPx / (windowWidth - padding) : page.heightPx / (windowHeight - padding);
		width = page.widthPx / constant;
	}

	return {
		height,
		width,
	};
};
